module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.d1a1596f.woff";